import React, { useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import {
	Avatar,
	Backdrop,
	Box,
	Button,
	Card,
	CardActions,
	CardContent,
	CircularProgress,
	IconButton,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import { useNavigate } from 'react-router-dom'
import { DOMAIN, IMGBB_API } from '../../utils/api'
import axios from 'axios'
import { getFromStorage, saveToStorage } from '../../utils/storage'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions } from '../../redux/store'
import { handleError } from '../../utils/error'
import { mainGreen } from '../../utils/color'

export default function EditProfile() {
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const dispatch = useDispatch()
	const [loadingUpload, setLoadingUpload] = useState(false)
	const navigate = useNavigate()
	const [userEdit, setUserEdit] = useState({
		values: { name: currentUser?.name, email: currentUser.email },
		errors: { name: '', email: '' },
	})
	const photo = currentUser?.photo
	const [fileUpload, setFileUpload] = useState()
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [preview, setPreview] = useState()
	const [showPhoto, setShowPhoto] = useState(true)

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	useEffect(() => {
		if (!fileUpload) {
			setPreview(undefined)
			return
		}

		const objectUrl = URL.createObjectURL(fileUpload)
		setPreview(objectUrl)

		return () => URL.revokeObjectURL(objectUrl)
	}, [fileUpload])

	const editUser = async function (imageUrl) {
		try {
			const response = await axios({
				method: 'PUT',
				headers: {
					Authorization: `Bearer ${token}`,
				},
				url: `${DOMAIN}/user/${currentUser.id}`,
				withCredentials: true,
				data: {
					id: currentUser.id,
					name: userEdit.values.name,
					photo: imageUrl || photo,
				},
			})
			saveToStorage('current-user', {
				...response.data.userEdit,
				accessToken: token,
			})
			dispatch(currentUserActions.isLogin(response.data.userEdit))
			navigate('/user/profile')
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const onFileChange = async (e) => {
		setFileUpload(e.target.files[0])
		setShowPhoto(false)
	}

	const uploadPhoto = async function () {
		setLoadingUpload(true)
		const formData = new FormData()
		formData.append('image', fileUpload)
		try {
			const response = await axios({
				method: 'POST',
				url: IMGBB_API,
				data: formData,
			})
			const imageUrl = response.data.data.display_url
			return imageUrl
		} catch (error) {
			alert(error.response.data.error.message)
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...userEdit.values, [name]: value }
		let newError = { ...userEdit.errors }

		if (name === 'name') {
			if (value.trim() === '') {
				newError[name] = '* Tên tài khoản không được bỏ trống'
			} else {
				newError[name] = ''
			}
		}

		setUserEdit({ values: newValue, errors: newError })
	}
	const handleSubmit = (event) => {
		event.preventDefault()

		if (userEdit.errors?.email !== '' || userEdit.errors?.name !== '') {
			return
		}
		if (fileUpload) {
			uploadPhoto()
				.then((imageUrl) => {
					editUser(imageUrl)
				})
				.catch((err) => console.log(err))
		} else {
			editUser()
		}
	}
	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				<Card>
					<Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
						<CardContent>
							<Typography
								sx={{
									fontWeight: 'bold',
									marginBottom: 1,
								}}>
								Cập nhật ảnh đại diện
							</Typography>
							{loadingUpload ? (
								<Box sx={{ paddingLeft: '20px' }}>
									<CircularProgress sx={{ color: mainGreen }} />
								</Box>
							) : (
								<>
									<Box display='flex' alignItems='flex-end' sx={{ mb: 2 }}>
										{showPhoto && (
											<Avatar
												sx={{ width: 80, height: 80, cursor: 'pointer' }}
												alt='avatar'
												src={photo}
												onClick={(e) => {
													openImageViewer(photo)
												}}
											/>
										)}
										{fileUpload && (
											<Avatar
												sx={{
													width: 80,
													height: 80,
													borderRadius: '50%',
												}}
												src={preview}
												alt='preview'
												onClick={(e) => {
													openImageViewer(photo)
												}}
											/>
										)}
										<>
											<IconButton sx={{ padding: '0' }}>
												<label htmlFor='choose-photo' style={{ display: 'flex', cursor: 'pointer' }}>
													<AddPhotoAlternateRoundedIcon sx={{ color: mainGreen }} />
												</label>
											</IconButton>
											<input
												accept='image/*'
												onChange={onFileChange}
												id='choose-photo'
												type='file'
												style={{ display: 'none' }}
											/>
										</>
									</Box>
									<Backdrop
										sx={{
											color: '#fff',
											zIndex: 999,
											left: mediaMd ? 300 : 0,
										}}
										open={isViewerOpen}
										onClick={closeImageViewer}>
										<img
											loading='lazy'
											src={currentImage}
											alt='attach'
											style={{
												maxHeight: '70%',
												maxWidth: '90%',
											}}
											onClick={(e) => {
												e.stopPropagation()
											}}
										/>
									</Backdrop>
								</>
							)}

							<TextField
								value={userEdit.values?.name}
								margin='normal'
								required
								fullWidth
								id='name'
								label='Tên tài khoản'
								name='name'
								autoComplete='name'
								autoFocus
								onChange={handleChange}
							/>
							<span style={{ color: '#ff0000' }}>{userEdit.errors?.name}</span>
							<TextField
								value={userEdit.values?.email}
								margin='normal'
								disabled
								fullWidth
								name='email'
								label='Email'
								type='email'
								id='email'
								autoComplete='email'
								onChange={handleChange}
							/>
						</CardContent>
						<CardActions sx={{ display: 'flex', justifyContent: 'center', pb: 5, px: 2 }}>
							<Button
								fullWidth
								type='submit'
								variant='contained'
								sx={{
									background: mainGreen,
									'&:hover': { background: mainGreen },
								}}>
								Cập nhật hồ sơ
							</Button>
						</CardActions>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
